export const CarpetasAdjuntos = {
    RequisitosAdmision: 'AdmissionRequirement',
    RequisitosGraduacion: 'GraduationRequirements',
    AnotacionesEstudiantes: 'StudentAnnotations',
    AdjuntosEstudiantes: 'StudentAttachments',
    LogoCompania: 'CompanyLogo',
}

export default CarpetasAdjuntos;